import { MeteredAddOnUsage } from "@addons/components/MeteredAddOnUsage";
import { IAddOnSlotProps, IMeteredAddOnDescriptor } from "../types";

export default function ProductAnalyticsUsageGraph({
  addOn: { subscribed, getUsage, getPricePerUnit },
}: IAddOnSlotProps<IMeteredAddOnDescriptor>) {
  const usage = getUsage();
  const pricePerEvent = getPricePerUnit();

  if (!subscribed || !usage || pricePerEvent === undefined) {
    return null;
  }

  return (
    <MeteredAddOnUsage
      dataTestId="ProductAnalyticsUsageListing"
      unitLabel="Ingested events"
      maxUnitLabel="events"
      usage={usage}
      pricePerUnit={pricePerEvent}
    />
  );
}
